import {Injectable} from '@angular/core';
import {Store} from '@ngxs/store';
import {AemGet, AemInitialize} from './aem.action';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AemGuard  {
  private init = false;

  constructor(
    private store: Store
  ) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    const resolve = (r: string) => `/${r.replace(/\.[^/.].*$/, '').replace(/^\//, '')}.webview.json`;

    if (!this.init) {
      this.init = true;

      return this.store
        .dispatch(new AemInitialize(null))
        .pipe(
          map(() => true)
        );
    }

    return this.store
      .dispatch(new AemGet(resolve(state.url)))
      .pipe(
        map(() => true)
      );
  }

  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.canActivate(childRoute, state);
  }
}
